<template>
  <div class="px-3 px-md-5 py-1 bg-theme"
    :class="{ 'progress-bar-striped progress-bar-animated': ballotStateIn('calculating_result') }">
    <span v-if="ballotSlide.disableAt && ballotStateIn(['open', 'countdown'])"
      class="float-end ms-3 text-monospace lead pb-sm-0">
      <b class="mb-0">
        <Countdown :end-time="Number(ballotSlide.disableAt)" @timesUp="timesUp = true" />
      </b>
    </span>
    <p class="lead mb-0">
      {{ closing ? $t("js.ballot.status.closing") : $t(`js.ballot.status.${ballotSlide.state}`) }}
      <span v-if="!canVote && !ballotStateIn(['calculating_result', 'finished'])"><br>
        {{ $t("js.ballot.cant_vote") }}
      </span>
    </p>
    <ResultProgress v-if="ballotStateIn(['calculating_result', 'finished']) && votingRoundReport"
      :progress="votingRoundReport.status" />
  </div>
</template>

<script setup lang="ts">
import Countdown from "../Countdown.vue";
import ResultProgress from "../ResultProgress.vue";
import { ref, computed } from "vue";
import { usePresentationStore } from "@/entrypoints/stores/presentation";
import type { PropType, E2E, LiveContestState, BallotSlide } from "@/types";

const props = defineProps({
  voted: {
    type: Boolean,
    default: false,
  },
  canVote: {
    type: Boolean,
    default: true,
  },
  ballotSlide: {
    type: Object as PropType<BallotSlide>,
    default: () => {},
  },
});

const presentationStore = usePresentationStore();

const showInfo = ref<boolean>(false);

const timesUp = ref<boolean>(false);

const votingRoundReport = computed(() => {
  return presentationStore.votingRoundReports?.find((votingRoundReport: E2E.VotingRoundReport) =>
    votingRoundReport.votingRoundReference === props.ballotSlide.votingRoundReference);
});

const closing = computed(() => {
  if (props.ballotSlide.state === "countdown" && timesUp.value) return true;
  else {
    timesUp.value = false;
    return false;
  }
});

const ballotStateIn = (ballotStates: LiveContestState | Array<LiveContestState>) => {
  if (props.ballotSlide) {
    if (Array.isArray(ballotStates)) {
      return ballotStates.includes(props.ballotSlide.state);
    } else {
      return ballotStates === props.ballotSlide.state;
    }
  }
  return false;
};
</script>

<style scoped>
.progress-bar-animated {
  --bs-progress-height: 1rem;
  --bs-progress-font-size: 0.75rem;
  --bs-progress-bg: var(--bs-secondary-bg);
  --bs-progress-border-radius: var(--bs-border-radius);
  --bs-progress-box-shadow: var(--bs-box-shadow-inset);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: var(--bs-primary);
  --bs-progress-bar-transition: width 0.6s ease;
}
</style>
